import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Player } from '@solverml/api';

/**
 * Componente "Dumb" (Vista) que muestra la información
 * principal del perfil de un jugador (nombre, fecha nacimiento, género).
 */
@Component({
  selector: 'app-player-detail-header',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule
  ],
  templateUrl: './player-detail-header.component.html',
  styleUrls: ['./player-detail-header.component.scss']
})
export class PlayerDetailHeaderComponent {
  /**
   * El objeto Player que se obtuvo de la API.
   */
  @Input({ required: true }) profile!: Player | null;
}
